import { Link } from "react-router-dom";

export default function Button(props){
    return (
        <div className="btn">
            <Link  to={props.btnUrl} class="button">{props.btnName}</Link>
        </div>
    );
}